
import React, { useState, useEffect } from 'react';
import { getTotalAccountCount } from '../../service/api/accountService';
import { getTotalDomainCount } from '../../service/api/domainService';
import { getTotalManagerCounts } from '../../service/api/domainUserService';
import AssignManager from './AssignManager';
import CustomerForm from '../../admin/Account/AccountForm/CustomerForm';

const DomainHeader = () => {

    const [domainCount, setDomainCount] = useState(0);
    const [managerCount, setManagerCount] = useState(0);
    const [accountCount, setAccountCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const domains = await getTotalDomainCount();
                const managers = await getTotalManagerCounts();
                const accounts = await getTotalAccountCount();

                setDomainCount(domains);
                setManagerCount(managers);
                setAccountCount(accounts);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCounts();
    }, []);

    if (loading) {
        return <div>Chargement des compteurs...</div>;
    }

    if (error) {
        return <div>Erreur : {error}</div>;
    }


    return(
        <>

            <div className="row ">
                {/* <!--column--> */}
                <div className="col-xl-12 ms-4  ">
                    <div className="kanban-header" >
                        <div className="left-title">
                            <div>
                                <h4 className="me-3 mb-0">TradeVault Services</h4>
                                <p className="mb-0" style={{width:'500px', height:'90px',paddingTop:'20px'}}>TradeVault Services, votre partenaire de confiance dans le monde complexe des valeurs mobilières et des marchés boursiers.</p>
                            </div>
								
                        </div>
                        <div className="right-title">
                            <div className="title-content">
                                 
                                <div className="ms-5 bread-btn">
                                    <a href="#" className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#newDomain">Nouveau domaine<svg className="ms-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z" fill="#FCFCFC"/>
                                        <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z" fill="#FCFCFC"/>
                                        </svg>
                                    </a>
                                </div>
                                <AssignManager/>
                            </div>
                        </div>	
                    </div>
                </div>
                {/* <!--/column--> */}
                <div className="d-flex flex-row flex-wrap gap-3 justify-content-start ">
                <div className="col-md-3">
                <div className="card counter ms-4">
                    <div className="card-body text-center p-3 d-flex flex-column align-items-center justify-content-center">
                    <div className="card-box-icon mb-3 d-flex align-items-center justify-content-center">
                    <svg
                                    width="50"
                                    height="50"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect x="3" y="3" width="18" height="18" rx="2" fill="url(#gradient-domain)" />
                                    <path
                                        d="M7 14L10 11L13 14L17 10"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <circle cx="7" cy="14" r="1" fill="white" />
                                    <circle cx="10" cy="11" r="1" fill="white" />
                                    <circle cx="13" cy="14" r="1" fill="white" />
                                    <circle cx="17" cy="10" r="1" fill="white" />
                                    <defs>
                                        <linearGradient
                                            id="gradient-domain"
                                            x1="4"
                                            y1="4"
                                            x2="20"
                                            y2="20"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#8E24AA" />
                                            <stop offset="1" stopColor="#6A1B9A" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                    </div>
                                    <div className="chart-num">
                                        <p className="mb-0">nombre total de domaines</p>
                                        <h2 className="mb-0">{domainCount}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                        <div className="card counter">
                        <div className="card-body text-center p-3 d-flex flex-column align-items-center justify-content-center">
                        <div className="card-box-icon mb-3 d-flex align-items-center justify-content-center">
                                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="10" fill="url(#gradient-manager)"/>
                                            <path d="M12 13C14.21 13 16 11.21 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9C8 11.21 9.79 13 12 13ZM6 18C6 16.34 10.33 15 12 15C13.67 15 18 16.34 18 18V20H6V18Z" fill="white"/>
                                            <defs>
                                                <linearGradient id="gradient-manager" x1="4" y1="4" x2="20" y2="20" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#1E88E5"/>
                                                <stop offset="1" stop-color="#1565C0"/>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div className="chart-num">
                                        <p className="mb-0">nombre total de gestionnaire</p>
                                        <h2 className="mb-0">{managerCount}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                <div className="card counter">
                <div className="card-body text-center p-3 d-flex flex-column align-items-center justify-content-center">
                <div className="card-box-icon mb-3 d-flex align-items-center justify-content-center">
                                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="10" fill="url(#gradient)"/>
                                            <path d="M12 13C14.21 13 16 11.21 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9C8 11.21 9.79 13 12 13ZM12 15C9.33 15 4 16.34 4 19V20H20V19C20 16.34 14.67 15 12 15Z" fill="white"/>
                                            <defs>
                                                <linearGradient id="gradient" x1="4" y1="4" x2="20" y2="20" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#4CAF50"/>
                                                <stop offset="1" stop-color="#2E7D32"/>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div className="chart-num">
                                        <p className="mb-0">nombre total de comptes</p>
                                        <h2 className="mb-0">{accountCount}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                   
                    </div>
                </div>
					
			

            <CustomerForm/>

        
        </>
    )
}

export default DomainHeader;